<template>
  <b-modal ref="modalDuplicationFavoris" size="md" title="Dupliquer les favoris"
    ok-title="Dupliquer" :ok-disabled="duplicationEnCours || !estValide"
    cancel-title="Annuler"
    no-close-on-backdrop
    @show="init()"
    @ok="dupliquer()">
    <template slot="default">
      <div class="form-group">
        <label for="selEtablissementsDestination">&Eacute;tablissements de destination</label>
        <MultiSelect id="selEtablissementsDestination" :value="destination.etablissementsIds" :items="etablissementsCourants" itemText="eRS" itemValue="eId" placeholder="Etablissements..." emptyText="Tous les établissements ont été ajoutés" @change="majEtablissements($event)" />
        <div class="error" v-if="!destination.etablissementsIds.length">Ce champ est requis</div>
      </div>
      <div class="flex-start">
        <ToggleButton name="ecraserMenuDestination" id="ecraserMenuDestination" v-model="destination.ecraserFavorisExistants" :height="21" :width="60"
          :labels="{checked: 'Oui', unchecked: 'Non'}" :color="{checked: '#ea0000de', unchecked: '#cccccc'}" v-tooltip="{ content: 'Attention, action irréversible qui supprimera tous les favoris présents sur le(les) établissement(s) de destination.'}" />
        <label for="ecraserMenuDestination"><i class="fas fa-exclamation-triangle ml-2"></i> Remplacer le(s) favori(s) de destination existant(s).</label>
      </div>
    </template>
  </b-modal>
</template>

<script>
import MultiSelect from '@/components/Inputs/MultiSelect'
import { dupliquerFavoris } from '@/api/gpao/mercuriales'
import { connecteData } from "@/mixins/connecteData"
import { required, minLength } from "vuelidate/lib/validators"
import { showAlerts } from '@/mixins/alerts'

export default {
  name: "ModalDuplicationFavoris",
  mixins: [ connecteData, showAlerts ],
  components: {
    MultiSelect
  },
  data() {
    return {
      destination: {
        etablissementsIds: [],
        ecraserFavorisExistants: false
      },
      duplicationEnCours: false,
      estValide: false,
      ecraserMenuDestination: false,
      ecraserRecetteDestination: false
    }
  },
  validations: {
    destination: {
      etablissementsIds: {
        required,
        minLength: minLength(1)
      },
      ecraserFavorisExistants: { required }
    }
  },
  methods: {
    init() {
      this.destination.etablissementsIds = []
      this.destination.ecraserFavorisExistants = false
    },
    majEtablissements(e) {
      this.destination.etablissementsIds = e
      this.checkValide()
    },
    checkValide() {
      this.estValide = this.destination.etablissementsIds.length
    },
    async dupliquer() {
      try {
        this.duplicationEnCours = true

        await dupliquerFavoris(this.etabCourantId, this.destination)
        this.$emit('favoris-dupliques', this.destination)
        
        this.alerteSucces("Favoris dupliqués avec succès !")
      } finally {
        this.duplicationEnCours = false
      }
    },
    show() {
      this.$refs.modalDuplicationFavoris.show()
    },
    hide() {
      this.$refs.modalDuplicationFavoris.hide()
    }
  }
}
</script>
